import HttpService from "./http.service";

class WildlifeAuctionService {
  getWildlifeAuctions = async (
    page,
    pageSize,
    sortColumn,
    sortColumnValue,
    searchValue,
    active, // new param
    filterParams
  ) => {
    let fetchUrl = "wildlife_auctions";

    const params = [];

    if (page) params.push(`page=${page}`);
    if (pageSize) params.push(`per_page=${pageSize}`);
    if (sortColumn) params.push(`sort_column=${sortColumn}`);
    if (sortColumnValue) params.push(`sort_column_value=${sortColumnValue}`);
    if (searchValue) params.push(`search_value=${encodeURIComponent(searchValue)}`);
    if (active !== undefined && active !== null) params.push(`active=${active}`);

    // 🔹 Flatten filterParams object to individual query params
    if (filterParams && typeof filterParams === "object") {
      Object.entries(filterParams).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== "") {
          params.push(`${encodeURIComponent(key)}=${encodeURIComponent(value)}`);
        }
      });
    }

    if (params.length > 0) {
      fetchUrl += "?" + params.join("&");
    }

    return await HttpService.get(fetchUrl);
  };


  addWildlifeAuction = async (newWildlifeAuction) => {
    const fetchUrl = "wildlife_auctions";
    return await HttpService.post(fetchUrl, newWildlifeAuction);
  };

  updateWildlifeAuction = async (id, data) => {
    const fetchUrl = `wildlife_auctions/${id}`;
    return await HttpService.put(fetchUrl, data);
  };

  updateActiveWildlifeAuction = async (id, data) => {
    const fetchUrl = `wildlife_auctions/${id}`;
    return await HttpService.patch(fetchUrl, data);
  };

  showWildlifeAuction = async (id) => {
    const fetchUrl = `wildlife_auctions/${id}`;
    return await HttpService.get(fetchUrl);
  };

  deleteWildlifeAuction = async (id) => {
    const fetchUrl = `wildlife_auctions/${id}`;
    return await HttpService.delete(fetchUrl);
  };

  startScraping = async (data) => {
    const fetchUrl = `wildlife_auctions_scrape`;
    return await HttpService.post(fetchUrl, data);
  };

  startScrapingListing = async (id) => {
    const fetchUrl = `wildlife_auctions_scrape/${id}`;
    return await HttpService.put(fetchUrl);
  }

  getListingCategories = async (active = 1) => {
    const fetchUrl = `wildlife_auctions_categories?active=${active}`;
    return await HttpService.get(fetchUrl);
  }

  getScrapingStatus = async () => {
    const fetchUrl = `wildlife_auctions_scraping_status`;
    return await HttpService.get(fetchUrl);
  }

  getBase64Image = async (url, id) => {
    const fetchUrl = `wildlife_get_base64_image?id=${id}&url=${encodeURIComponent(url)}`;
    return await HttpService.get(fetchUrl);
  }
}

export default new WildlifeAuctionService();
